import { PrinterPosEditIcon } from './PrinterPosEditIcon';

/**
 * author: Colton Wiscombe
 * id 954D4E9A-A4EF-414E-9AC3-0B07DA479BE9
 * name printer-pos-edit
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-edit.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptEditIcon = PrinterPosEditIcon;
export default PrinterReceiptEditIcon